import { NetworkStatus, USState } from '@strata/constants';

import { fmhNpiAPI, REFERENCE_API_URL } from 'api/APIBase';

export async function getPayerDetails(payerId: string) {
    const url = `${REFERENCE_API_URL}/payers/${payerId}`;
    return fmhNpiAPI({ url })
        .get()
        .notFound(() => ({}))
        .json<{
            payer_id: string;
            payer_name: string;
            payer_email?: string;
            features?: string[];
        }>();
}

/** Gets prescriber information */
export async function getPrescriberInfo(npi: string) {
    const url = `${REFERENCE_API_URL}/prescribers/${npi}`;
    return fmhNpiAPI({ url })
        .get()
        .notFound(() => ({}))
        .json<{
            prescriber_npi: string;
            first_name: string;
            last_name: string;
            organization_name?: string;
            practice_npi?: string;
            telephone_number?: string;
            fax_number?: string;
            address_1?: string;
            address_2?: string;
            city?: string;
            state?: USState;
            postal_code?: string;
        }>();
}

/** Gets prescriber information for multiple npis */
export async function getBulkPrescriberInfo(npis: string[]) {
    const url = `${REFERENCE_API_URL}/prescribers/bulk_lookup`;
    return fmhNpiAPI({ url }).post(npis).json<{
        prescribers: { prescriber_npi: string; first_name: string; last_name: string }[];
        not_found: string[];
    }>();
}

/** Gets supplier details based on supplier NPI */
export async function getSupplierDetails(supplierNpi: string) {
    const url = `${REFERENCE_API_URL}/suppliers/${supplierNpi}`;
    return fmhNpiAPI({ url })
        .get()
        .notFound(() => ({}))
        .json<{
            supplier_npi: string;
            organization_name?: string;
            network_status: NetworkStatus;
            telephone_number?: string;
            fax_number?: string;
            address_1?: string;
            address_2?: string;
            city?: string;
            state?: USState;
            postal_code?: string;
            email?: string;
            extra_taxonomy_codes: { taxonomy_code: string; taxonomy_description: string }[];
        }>();
}

/** Gets supplier child NPIs for a parent NPI */
export async function getSupplierChildren(parentSupplierNpi: string) {
    const url = `${REFERENCE_API_URL}/suppliers/children/${parentSupplierNpi}`;
    return fmhNpiAPI({ url })
        .get()
        .notFound(() => ({}))
        .json<{ npis: string[]; billing_supplier_npi?: string }>();
}

export async function getSupplierFeatures(npi: string) {
    const url = `${REFERENCE_API_URL}/suppliers/${npi}/features`;
    return fmhNpiAPI({ url }).get().json<{ supplier_feature_id: string; description: string }[]>();
}
